import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export function useBulkCreate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: {
      keywords: string[];
      site_id?: string | null;
      language?: string;
      tone?: string;
      audience?: string;
      article_type?: 'general' | 'how_to' | 'list';
      section_length?: 'short' | 'medium' | 'long';
      template_type?: string;
      ai_model?: string;
      auto_generate?: boolean;
    }) =>
      api.post<{ created: number; content_ids: string[]; hint: string }>('/api/app/bulk/create', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['content'] }),
  });
}
